// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"390":"045e42db","787":"175b8b0e"}[chunkId] + ".chunk.js";
};